module.exports = __webpack_public_path__ + "7b4aa2e2.mp4";


//////////////////
// WEBPACK FOOTER
// ./public/images/espera.mp4
// module id = 1151
// module chunks = 0 1 2